import { render, staticRenderFns } from "./rfq-order.vue?vue&type=template&id=72a127df&scoped=true"
import script from "./rfq-order.vue?vue&type=script&lang=js"
export * from "./rfq-order.vue?vue&type=script&lang=js"
import style0 from "./rfq-order.vue?vue&type=style&index=0&id=72a127df&prod&lang=css"
import style1 from "./rfq-order.vue?vue&type=style&index=1&id=72a127df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a127df",
  null
  
)

export default component.exports